import { render } from "./TrustedIssuersListsShowView.vue?vue&type=template&id=e3c05d36"
import script from "./TrustedIssuersListsShowView.vue?vue&type=script&lang=js"
export * from "./TrustedIssuersListsShowView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__